export const games = {
    yx: "Oyun",
    yxms: "Şifreli oyunlarda tüm sonuçlar, hash formunda önceden oluşturulur ve hiçbir kişinin iradesiyle değiştirilemez, mutlak adalet ve şeffaflık garanti edilir!",
    mnsm: "Demo Oyna",
    ljqw: "Hemen Oyna",
    loading: "Yükleniyor, lütfen bekleyin",
    dyh: "Çeşitli opsiyon sözleşmeleri arasından seçim yapın, yüksek getiriler, kısa vadeli yüksek yatırım getirisi",
    qyhy: "Opsiyon Sözleşmeleri",
    qsyhys: "Opsiyonlar",
    kd: "Pozisyon Aç",
    qt: "Eğlenceli Tahmin",
    ljjy: "Hemen İşlem Yap",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/games/tr.js